import type { Subscription } from '~/interfaces/subscriptions';

export const useSubscriptionPermissions = (subscription: Subscription, isLoggedIn: boolean) => {
  if (!isLoggedIn) {
    return {
      canUnsubscribe: true,
      canManageOrders: false,
    };
  }

  return {
    canUnsubscribe: ['read-only', 'write'].includes(subscription.access_type),
    canManageOrders: subscription.access_type === 'write',
  };
};
